var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column col-12"},[_c('v-card',{staticClass:"chat-wrapper"},[_c('messages-log')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }